import { createActions } from 'redux-actions';

export const { tryDeleteWish, clearWishToDelete } = createActions({
  TRY_DELETE_WISH: wishId => wishId,
  CLEAR_WISH_TO_DELETE: () => {}
});



// WEBPACK FOOTER //
// ./src/store/deleteWish/actions.js